module.exports = __webpack_public_path__ + "img/header-or-menachem-ch.3dff135c.png";